export default {
  SIGNIAPP_URL: window.SIGNIAPP_FRONTEND_BASE_URL,
  SUPPORT_EMAIL: 'support@signicat.com',
};
